module.exports = __webpack_public_path__ + "static/media/current_cycle_left.dbc5a162.svg";